import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QryptLogoDark, QryptSymbolDark } from "../components/ui";
export const AuthPageLayout = ({ title, subtitle, cardClassName, children })=>{
    const cardClasses = cardClassName ? `bg-white p-12 rounded-lg shadow-[0_0_20px_-10px_rgb(0,0,0,0.5)] max-w-full flex flex-col items-center z-10 ${cardClassName}` : "bg-white p-12 rounded-lg shadow-[0_0_20px_-10px_rgb(0,0,0,0.5)] w-[440px] max-w-full flex flex-col items-center z-10";
    return /*#__PURE__*/ _jsxs("div", {
        className: "min-h-screen flex flex-col items-center justify-center bg-gray-100 relative",
        children: [
            /*#__PURE__*/ _jsx(QryptSymbolDark, {
                className: "absolute inset-0 opacity-[0.03] z-0",
                style: {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover"
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cardClasses,
                children: [
                    /*#__PURE__*/ _jsx(QryptLogoDark, {
                        className: "mb-6",
                        width: 160,
                        height: 48
                    }),
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-lg text-navy-60 mb-4",
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ _jsx("p", {
                        className: "text-sm text-gray-600 mb-8 text-center",
                        children: subtitle
                    }),
                    children
                ]
            })
        ]
    });
};
export default AuthPageLayout;
